import Vue from 'vue'
import { 
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Button,
    Input,
    Tabs,
    TabPane,
    Container,
    Header,
    Aside,
    Main,
    Breadcrumb,
    BreadcrumbItem,
    Select,
    Option,
    Carousel,
    CarouselItem,
    Popover,
    Loading,
    Pagination,
    DatePicker,
    Empty,
    Table,
    TableColumn
} from 'element-ui'
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Button)
Vue.use(Input)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Select)
Vue.use(Option)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Popover)
Vue.use(Pagination)
Vue.use(DatePicker)
Vue.use(Empty)
Vue.use(Loading.directive);
Vue.use(Table);
Vue.use(TableColumn);

Vue.prototype.$loading = Loading.service;


